import {gql} from '@apollo/client'
export const queryOpenAPIAppList=gql`
query OpenAPIAppList($page: Int!, $count: Int!, $isPermanent: Boolean, $name: String,$startDate: Date, $endDate: Date) {
  openAPIAppList(page: $page, count: $count, isPermanent: $isPermanent, name: $name,startDate: $startDate, endDate: $endDate) {
    data {
      client
      appName
      clientId
      solutions
      state
      organization
      trialTime
      expiredTime
      lastChangeTime
    }
    total
  }
}
`